<!-- @format -->

<div id="pdp-textile-label">
	<hmf-accordion
		label="Filling Material"
		size="large"
		icon="nature-waves"
		[expandOverContent]="false">
		<div
			class="textile-label-body label-base"
			myPanelBody
			[innerHTML]="textileLabel() | bypassSanitization"></div>
	</hmf-accordion>
</div>
